import { AxiosError } from 'axios'

import { type HttpClientError } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import {
  ShipmentChargesRepository,
  type UploadChargeAttachmentParams,
} from '../infra/ShipmentChargesRepository'

const DEFAULT_ATTACHMENT_ERROR_MESSAGE =
  'The charge was created but the attachment could not be uploaded. Please try again.'

export type UploadChargeAttachmentDependencies = {
  repository: ShipmentChargesRepository
}

export function uploadChargeAttachmentFactory({ repository }: UploadChargeAttachmentDependencies) {
  return async function uploadAttachment({
    chargeUUID,
    file,
    config,
  }: UploadChargeAttachmentParams) {
    try {
      const uploadedAttachment = await repository.uploadChargeAttachment({
        chargeUUID,
        file,
        config,
      })

      return uploadedAttachment
    } catch (error) {
      let errorMessage = DEFAULT_ATTACHMENT_ERROR_MESSAGE

      if (error instanceof AxiosError) {
        const axiosError = error as HttpClientError<{ attachments?: string[] }>

        errorMessage =
          axiosError?.response?.data?.attachments?.[0] || DEFAULT_ATTACHMENT_ERROR_MESSAGE
      }

      throw errorMessage
    }
  }
}

export function uploadChargeAttachment({ chargeUUID, file, config }: UploadChargeAttachmentParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentChargesRepository({ httpClient })
  const uploadAttachment = uploadChargeAttachmentFactory({ repository })

  return uploadAttachment({ chargeUUID, file, config })
}
